import axios from 'axios';

// Single configured axios instance for the whole app. Import this instead of
// axios and use relative paths (e.g. api.get('/cases')):
//   - baseURL is the backend /api root,
//   - the bearer token is attached automatically from localStorage,
//   - a 401 on a non-auth request clears the session and redirects to /login.
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL || ''}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';
    // Auth endpoints handle their own 401s (bad password, stale token on load);
    // for everything else a 401 means the session expired -> log out.
    if (status === 401 && !url.includes('/auth/')) {
      localStorage.removeItem('token');
      if (
        typeof window !== 'undefined' &&
        !window.location.pathname.startsWith('/login')
      ) {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
